<template>
  <div class="pix-register-account__key">
    <ChooseTypeOfPixKey v-if="chooseAnotherKey" @pix-type="setPixType" />
    <div v-else-if="this.user.cpf">
      <form @submit.prevent="submit" autocomplete="off">
        <KeyCPF
          v-if="pixType === 'cpf'"
          v-bind:another-key.sync="chooseAnotherKey"
          :cpf="user.cpf"
        />
        <KeyPhone v-else-if="pixType === 'phone'" @change="setPixKey" />
        <KeyEmail v-else-if="pixType === 'email'" @change="setPixKey" />
        <KeyAleatory v-else-if="pixType === 'evp'" @change="setPixKey" />

        <ResponsabilityBox
          v-bind:value.sync="checkPix"
          :has-error="showCheckError"
        />

        <div class="pix-register-account__button">
          <button
            class="button is-support is-big"
            type="submit"
            :class="{
              'is-disabled': !user.cpf || !checkPix || !keyPix || hasErrors,
              'is-loading': formLoading,
            }"
          >
            Avançar
          </button>
        </div>
      </form>
    </div>

    <BaseModalPassword
      ref="password"
      :isWithdraw="false"
      :userData="user"
      message="Para prosseguir com o seu cadastro de chave PIX, por favor, confirme a sua senha de acesso no Casar.com"
      @token-extra="getTokenExtra"
    />
    <ValidationPhoneModal
      ref="modalValidationPhone"
      :isRegisterNumber="false"
      :btnCloseAtivated="true"
      nextStep="wallet"
      @validation-phone="handleValidationPhone"
    />
    <BaseModalError
      ref="errorApi"
      :title="title"
      :icon="iconModal"
      :message="`<strong>${errorMessage}</strong>`"
      :sub-message="message2"
      :hasButton="hasButton"
    />
  </div>
</template>

<script>
import WalletApi from '@/lib/api/Wallet'
import BaseModalError from '@/components/BaseModalError.vue'
import ValidationPhoneModal from '@/components/Profile/Sms/ValidationPhoneModal.vue'
import BaseModalPassword from '@/components/BaseModalPassword.vue'
import ChooseTypeOfPixKey from './Forms/ChooseTypeOfPixKey.vue'
import ResponsabilityBox from '../ResponsabilityBox.vue'
import KeyCPF from './Forms/KeyCPF.vue'
import KeyPhone from './Forms/KeyPhone.vue'
import KeyEmail from './Forms/KeyEmail.vue'
import KeyAleatory from './Forms/KeyAleatory.vue'

export default {
  components: {
    BaseModalError,
    ValidationPhoneModal,
    BaseModalPassword,
    ChooseTypeOfPixKey,
    ResponsabilityBox,
    KeyCPF,
    KeyPhone,
    KeyEmail,
    KeyAleatory,
  },

  props: {
    pixKeyType: {
      type: String,
      required: false,
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    user() {
      return this.$store.state.wallet.chosenOwner
    },

    userDataTransfer: {
      get() {
        return this.$store.state.wallet.userDataTransfer
      },
      set(payload) {
        this.$store.dispatch('setSelectedAccountTransfer', payload)
      },
    },

    listPixKeys() {
      return this.$store.state.wallet.listPixKey
    },

    wedSiteInfo: {
      get() {
        return this.$store.state.app.wedSiteInfo
      },
      set(payload) {
        this.$store.dispatch('app/setWedSiteInfo', payload)
      },
    },

    pixKeyRegisteredBefore() {
      if (!this.listPixKeys || !this.listPixKeys.length) return false

      const keyPixWithoutCharacter = this.getPixKeyOnlyNumbers(this.keyPix)

      const pixKey = this.listPixKeys.filter(
        (pix) =>
          this.getPixKeyOnlyNumbers(pix.pix_key) === keyPixWithoutCharacter
      )

      return pixKey
    },
  },

  data() {
    return {
      chooseAnotherKey: false,
      keyPix: null,
      data: null,
      checkPix: false,
      errorMessage: '',
      formLoading: false,
      iconModal: 'error-api',
      message2: '',
      dateFormated: null,
      title: 'Erro ao cadastrar chave PIX',
      hasButton: true,
      showCheckError: false,
      pixType: 'cpf',
      hasErrors: false,
    }
  },

  created() {
    this.pixType = this.pixKeyType || 'cpf'
    this.keyPix = this.user.cpf
  },

  methods: {
    async submit() {
      if (!this.keyPix || this.hasErrors) return

      if (!this.checkPix) {
        this.showCheckError = true
        return
      }

      this.showCheckError = false

      if (!this.listPixKeys) {
        this.$refs.password.open()
        return
      }

      if (this.pixKeyRegisteredBefore.length > 0) {
        this.showKeyPixError()
        this.$refs.errorApi.open()
      } else {
        this.$refs.password.open()
      }
    },

    setPixType(type) {
      this.keyPix = null
      this.checkPix = false
      this.pixType = type
      this.chooseAnotherKey = false

      if (type !== 'cpf') {
        this.$router.push({
          path: `/carteira/cadastrar-pix/${type}`,
          params: {
            transfer: 'pix',
          },
        })
      }
    },

    setPixKey(payload) {
      this.keyPix = payload.key
      this.hasErrors = payload.error
    },

    getPixKeyOnlyNumbers(key) {
      if (key.length < 32 && key.indexOf('@') == -1) {
        return key.replace(/[^\d]/g, '')
      }
      return key
    },

    showKeyPixError() {
      this.title = 'Cadastro de chave PIX'
      this.iconModal = 'key-registered'
      this.errorMessage = 'Oops, a chave PIX informada já está cadastrada!'
      this.message2 =
        'Para transferir para essa chave, acesse a página “Transferir para conta” e localize-a em “Minhas chaves cadastradas”. <br><br>Lembramos que o horário para transferências por PIX está disponível todos os dias das <span class="txt-color-support">10h00 às 18h00</span> - horário de Brasília. Não será possível solicitar transferências fora deste período.'

      this.hasButton = false

      if (
        this.pixKeyRegisteredBefore?.verified != 1 ||
        this.pixKeyRegisteredBefore?.enabled_to_use != 1
      ) {
        this.iconModal = 'key-validation'
        this.errorMessage =
          'Oops, essa chave PIX já foi cadastrada anteriormente.'
        this.message2 =
          'Para acompanhar o status desta solicitação, acesse a página “transferir para conta” e clique sobre a sua chave PIX.'
      }
    },

    getTokenExtra(payload) {
      payload.token ? this.$refs.modalValidationPhone.open(payload.token) : ''
    },

    getDataAccount() {
      if (this.user) {
        if (this.pixType === 'cpf') {
          this.keyPix = this.user.cpf
        }

        if (this.keyPix) {
          return {
            wallet_id: this.logonToken.token_payload.wallet_id,
            pix_key: this.keyPix,
            pix_type: this.pixType,
            owner_cpf: this.user.cpf,
            owner_full_name: this.user.name,
          }
        }
      }
    },

    handleValidationPhone(tokenPhoneValidated) {
      this.formLoading = true

      if (tokenPhoneValidated) {
        const data = this.getDataAccount()
        this.setRegisterPixAccount(tokenPhoneValidated, data)
      }
    },

    setRegisterPixAccount(tokenPhoneValidated, data) {
      if (
        this.logonToken &&
        this.logonToken.token &&
        this.logonToken.token_payload.wed_id
      ) {
        const tokens = `Bearer ${this.logonToken.token}, Bearer ${tokenPhoneValidated}`

        const walletapi = new WalletApi(this.logonToken)
        walletapi
          .registerAccountPix(
            data,
            this.logonToken.token_payload.wed_id,
            tokens
          )
          .then((response) => {
            if (response.data.data) {
              localStorage.setItem(
                `time${response.data.data.id}`,
                response.data.meta.created_date
              )

              this.userDataTransfer = response.data.data

              const formated =
                this.userDataTransfer.enabled_to_use_at.split(' ')

              const resul = formated[0].split('-')
              this.dateFormated = resul[2] + '/' + resul[1] + '/' + resul[0]

              !response.data.data.enabled_to_use
                ? this.redirectValidationPix(response.data.data)
                : this.redirectToWithdraw()
            }
          })
          .catch((error) => {
            this.iconModal = 'erro-transfer-pix'
            this.errorMessage =
              '<strong>Infelizmente não foi possível completar seu registro de chave PIX!</strong>'
            this.message2 =
              'Confira os dados de sua conta bancária ou<br/>entre em contato conosco por meio do chat.'
            if (error.response.status == 409 || error.response.status == 404) {
              this.errorMessage = error.response.data.error.message
            }
            this.$refs.errorApi.open()
            console.error(error)
          })
          .finally(() => (this.formLoading = false))
      }
    },

    redirectValidationPix(data) {
      const formated = data.enabled_to_use_at.split(' ')

      const resul = formated[0].split('-')
      this.dateFormated = resul[2] + '/' + resul[1] + '/' + resul[0]

      this.$router.push({
        name: 'carteira-validacao-pix',
        params: {
          id: data.id,
          verified: data.verified,
          enabled_to_use: data.enabled_to_use,
          enabled_to_use_at: data.enabled_to_use_at,
          email: this.wedSiteInfo.site_email,
          data: this.dateFormated,
          from: 'carteira-cadastro-pix',
        },
      })
    },

    redirectToWithdraw() {
      this.$router.push({
        name: 'carteira-saque-pix',
        params: {
          transfer: this.$route.params.transfer,
          from: 'carteira-cadastro-pix',
        },
      })
    },
  },
}
</script>

<style lang="scss">
.pix-register-account {
  overflow: hidden;

  .column {
    @media (max-width: $tablet) {
      padding-bottom: 0;
      padding-top: 0;
    }
  }

  &__key {
    padding: 20px;
    margin-top: 35px;
  }

  &__title {
    font-size: 20px;
    line-height: 1.2;
    font-weight: bold;
    color: $gray-6;
  }

  &__subtitle {
    padding-top: 8px;
    font-size: 16px;
    line-height: 1.5;
    color: $gray-5;
  }

  &__button {
    margin-top: 40px;
    .is-disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
}
</style>
